import { PlayerName } from './PlayerName';

export interface PlayerLinkInlineProps {
  /** The player to render as a link; falsy renders a muted placeholder. */
  p: { name: string } | null | undefined;
  /** Called before navigating, e.g. to dismiss the surrounding overlay. */
  onClose: () => void;
  /** Optional click handler receiving the player. */
  onPlayerClick?: (p: { name: string }) => void;
}

/**
 * Inline player link (name only, no styling) — for headers.
 * Extracted verbatim from the monolith (legacy/App.tsx); markup unchanged so
 * styling is identical.
 */
export function PlayerLinkInline({ p, onClose, onPlayerClick }: PlayerLinkInlineProps) {
  if (!p) return <span className="text-ink-3 italic">?</span>;
  return (
    <button
      onClick={() => {
        onClose();
        onPlayerClick?.(p);
      }}
      className="hover:underline"
      style={{
        background: 'transparent',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        font: 'inherit',
        color: 'inherit',
      }}
    >
      <PlayerName player={p} />
    </button>
  );
}
